import { render, staticRenderFns } from "./efp.vue?vue&type=template&id=04f4864e&"
import script from "./efp.vue?vue&type=script&lang=js&"
export * from "./efp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports